Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
exports.BaseTransport = base_1.BaseTransport;
var fetch_1 = require("./fetch");
exports.FetchTransport = fetch_1.FetchTransport;
var xhr_1 = require("./xhr");
exports.XHRTransport = xhr_1.XHRTransport;
var new_fetch_1 = require("./new-fetch");
exports.makeNewFetchTransport = new_fetch_1.makeNewFetchTransport;
var new_xhr_1 = require("./new-xhr");
exports.makeNewXHRTransport = new_xhr_1.makeNewXHRTransport;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/dist/transports/index.js
// module id = 908
// module chunks = 1